
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface IPAccessResult {
  allowed: boolean;
  country?: string;
  countryCode?: string;
  ip?: string;
  error?: string;
  vpnDetected?: boolean;
}

export const useIPAccess = () => {
  const [ipAccess, setIpAccess] = useState<IPAccessResult | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkIPAccess = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('check-ip-access', {
          method: 'POST',
        });

        if (error) {
          setIpAccess({ allowed: false, error: 'Failed to verify location' });
        } else {
          setIpAccess(data);
        }
      } catch (err) {
        setIpAccess({ allowed: false, error: 'Network error' });
      } finally {
        setLoading(false);
      }
    };

    checkIPAccess();
  }, []);

  return { ipAccess, loading };
};
